export default __webpack_public_path__ + "static/media/centralrepo.40a96c70.svg";